window.addEventListener('DOMContentLoaded', function() {

  const $dropdownContent = $(".search-dropdown-content");
  const $dropdown = $(".search-dropdown");

  function openDropdown() {
    $dropdown.addClass("is-active");
  }

  function closeDropdown() {
    $dropdown.removeClass("is-active");
  }

  function getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          closeDropdown();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        $dropdownContent.html(resultsMarkup);
        openDropdown();
      })
      .catch((error) => {
        closeDropdown();
        throw error;
      });
  }
  
  const $searchInput = $(".search-input");
  let debounce = null;
  
  $searchInput.on("focus keyup", function(){
    clearTimeout(debounce);
    const query = $(this).val().trim();
    if (query.length) {
        debounce = setTimeout(function(){
        getSearchResults(query);
      }, 300);
    }
  });

  // Close predictive search if user clicks outside search
  document.addEventListener(
    "click",
    (event) => {
      if (!event.target.closest(".search-dropdown")) {
        closeDropdown();
      }
    },
    false
  )
  
});